export const NAME = 'coilBindingMachines';